import type {
  FileResponse,
  GetListPossibleReportOptionsRequest,
  GetListResponseOfReportInstanceMembershipResponse,
  GetListResponseOfSelectOption,
  GetReportInstanceMembershipListRequest,
  ReportInstanceMembershipRequest,
  ReportInstanceMembershipResponse,
} from 'src/api/ProactApiClient';
import {reportInstanceApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

export const reportInstanceApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getReportInstanceList: builder.query<
      GetListResponseOfReportInstanceMembershipResponse,
      GetReportInstanceMembershipListRequest
    >({
      queryFn: clientQuery(request => reportInstanceApiClient.list(request)),
      providesTags: ['ReportInstances'],
    }),
    getReportInstancePotentialReports: builder.query<
      GetListResponseOfSelectOption,
      GetListPossibleReportOptionsRequest
    >({
      queryFn: clientQuery(request =>
        reportInstanceApiClient.listPotentialReports(request)
      ),
      providesTags: ['ReportInstances'],
    }),
    createReportInstance: builder.mutation<
      ReportInstanceMembershipResponse,
      ReportInstanceMembershipRequest
    >({
      queryFn: clientQuery(request => reportInstanceApiClient.create(request)),
      invalidatesTags: ['ReportInstances'],
    }),
    deleteReportInstance: builder.mutation<FileResponse | null, number>({
      queryFn: clientQuery(id => reportInstanceApiClient.delete(id)),
      invalidatesTags: ['ReportInstances'],
    }),
  }),
});

export const {
  useGetReportInstanceListQuery,
  useGetReportInstancePotentialReportsQuery,
  useCreateReportInstanceMutation,
  useDeleteReportInstanceMutation,
} = reportInstanceApi;
